<mat-icon class="material-symbols-outlined lightbulb"> lightbulb </mat-icon>
